const helpContents = require('./help/')
const articles = require('./articles')

module.exports = {

  common: {
    noun: {
      time: "时间",
      amount: "数量",
      balance: '余额',
      price: "价格",
      allowance: "交易授权",
      errors: "错误信息",
      maker: "挂单者[Maker]",
      taker: "吃单者[Taker]",
      buyer: "买方",
      makerFee: "挂单[Maker]手续费",
      takerFee: "吃单[Taker]手续费",
      protocolFee: "协议费",
      block: "区块",
      makerToken: "卖出代币",
      takerToken: "买入代币",
      makerTokenAmount: "卖出代币数量",
      takerTokenAmount: "买入代币数量",
      orderStatus: "挂单状态",
      orderAmountFilled: "已卖出代币数量",
      orderAmountAvailable: "剩余代币数量",
      fillable: "挂单是否仍然有效",
      relayer: "中继",
      max: "最大值",
      amountFillable: "可交易数量",
      language: "语言",
      me: "我",
      notification: "通知",
      timePeriod: {
        'minutes': '分钟',
        'hours': '小时',
        'days': '日',
        'weeks': '星期',
        'months': '月',
        'years': '年',
      },
      version: "版本",
    },
    verb: {
      sell: "卖出",
      buy: "买入",
      haveSent: "已卖出",
      haveReceived: "已买入",
      reset: "重置",
      cancel: "取消",
      tryAgain: "重试",
      check: "查看",
      checkAgain: "再次查看",
      checking: "正在查询",
      adding: "正在添加",
      removing: "正在移除",
      close: "关闭",
      clear: "清空",
      select: "选择",
    },
    phrase: {
      setAllowance: "添加交易授权",
      addNewToken: "添加新的代币",
      noOrderFound: "目前没有挂单",
      noRecentTrade: "没有最近的交易记录",
      viewOrder: "显示挂单",
      fillOrder: "吃单",
      cancelOrder: "撤销挂单",
      deleteOrderRecord: "删除记录",
      clear: "清空",
      learnMore: "了解更多",
      visitOldVersion: "访问旧版",
      fieldIsRequired: "此项为必填",
      loading: "加载中...",
      viewDetails: "查看详情",
      whatsNew: "更新通知",
    },
    token: {
      name: "名称",
      symbol: "符号",
      decimals: "小数点位数",
      address: "合约地址",
    },
    orderForm: {
      label: {
        tokenToSell: "卖出代币",
        tokenToBuy: "买入代币",
        amountToSell: "卖出数量",
        amountToBuy: "买入数量",
        amountToFill: "吃单数量",
        whoCanFill: "交易对象",
        takerAccount: "吃单账号",
        expirationTime: "过期时间",
        now: "现在时间",
        enterPriceAs: "价格显示方式",
      },
      option: {
        whoCanFill: {
          anybody: "所有人都可以吃单",
          selected: "仅指定账号可以吃单",
        }
      },
    },
    err: {
      generic: "对不起！出错了。您可以尝试重新加载本页。",
      amount: {
        max: "最大值",
        mustNumber: "必须是数字",
        mustGreaterThanZero: "必须大于0",
        insufficientBalance: "余额不足",
        insufficientAllowance: "没有足够交易权限",
        tooManyDecimals: "小数点后位数过多",
        maxValCanFill: "可吃单的最大值: "
      },
      address: {
        addMissing: "请输入账号地址",
        invalidAdd: "地址不合规范",
        ownAdd: "这是您自己的账户地址",
      },
      time: {
        mustBeFuture: "必须是未来的时间",
      },
    },
  },

  nav: {
    home: "首页",
    about: "关于",
    aboutLedgerDex: "关于 LedgerDex",
    terms: "服务条款",
    unkownNetwork: "未知网络",
    myTokens: "我的代币",
    marketplace: "交易中心",
    createNewOrder: "创建新挂单",
    help: "帮助",
    trade: "交易",
    myOrders: "我的挂单",
    ordersForMe: "发给我的挂单",
    tradeHistory: "交易历史",
    login: "登录",
    logout: "退出",
    darkMode: "黑夜模式",
    orderDetails: "挂单内容",
    fillJsonOrder: "使用JSON代码吃单",
  },

  compPendingTx: {
    intro: "您的操作指令已经被提交到以太坊网络，可能会需要一些时间才能完成。您并不需要在这个页面等候。",
    btnViewTx: "查看",
  },

  compWrap: {
    title: "包装 ETH",
    labelAmount: "包装数量:",
    btnConvert: "把 ETH 兑换成 WETH",
    btnConvertLoading: "兑换中，请稍候",
    successMessage: "{amount} ETH已成功兑换成WETH。",
  },

  compUnwrap: {
    title: "卸装 WETH",
    labelAmount: "卸装数量:",
    btnConvert: "把 WETH 兑换成 ETH",
    btnConvertLoading: "兑换中，请稍候",
    successMessage: "{amount} WETH已成功兑换成ETH。",
  },

  compSetAllowance: {
    titleSet: "添加交易授权",
    titleRemove: "取消交易授权",
    introSet: "为确保智能合约能够安全地完成您的代币交易，我们首先需要您授予智能合约替您进行代币交易的权力，这一过程叫做交易授权（Allowance），对于每一种您需要卖出的代币，在交易之前都需要添加交易授权。",
    confirmRemove: "您确定要取消代币 {tokenSymbol} 的交易授权码？",
    buttonTextSet: '添加交易授权',
    buttonTextRemove: '取消交易授权',
    buttonTextSetting: '添加中，请稍候',
    buttonTextRemoving: '取消中，请稍候',
    successSetMessage: "已成功为 {tokenSymbol} 添加交易授权。",
    successRemoveMessage: "已成功取消 {tokenSymbol} 的交易授权。",
  },

  compAddTokenTracking: {
    title: "添加代币",
    optSelectTitle: "从经过认证的代币中选择",
    optSelectIntro: "以下是一些经过认证的代币，您可以从中进行选择。",
    optSelectNoMore: "您已经添加了全部经过认证的代币。您可以通过搜索代币的方式添加更多代币。",
    optSearchTitle: "搜索想要添加的代币",
    optSearchLabel: "输入您想要添加的 ERC20 代币的合约地址:",
    optSearchTxtExample: "例如",
    btnTxtAddToken: "添加代币",
    btnTxtAddingToken: "正在添加代币，请稍候",
    btnTxtSearchToken: "搜索代币",
    btnTxtSearchingToken: "搜索中",
    optSearchResultNotFoundTxt: "代币不存在或不符合ERC20代币标准。请检查代币的合约地址并重试。",
    optSearchResultFoundTitle: "搜索结果",
    optSearchResultFoundAgreement: "我已经亲自检查过这一代币，并确认无误。如果这一代币出现任何问题，我本人将承担全部责任。",
    searchErrInvalidAddress: "合约地址不合规范",
    searchErrAlreadyAdded: "您已经添加过这个代币了",
    successMessage: "代币 {tokenSymbol} 添加成功。",
  },

  compRemoveTokenTracking: {
    title: "取消代币关注",
    txtConfirm: "您确定要取消关注这个代币吗？",
    txtCanAddBack: "您可以随时重新关注这个代币。",
    btnStopTracking: "取消代币关注",
    btnStopTrackingLoading: "取消中，请稍候",
    successMessage: "已成功取消关注代币 {tokenSymbol}。",
  },

  compSendToken: {
    title: "发送代币",
    intro: "发送 {tokenSymbol}",
    labelRecipientAdd: "接收账户地址:",
    labelAmount: "发送数量",
    btnSend: "发送",
    btnSending: "发送中，请稍候",
    successMessage: "已成功发送 {tokenAmount} {tokenSymbol} 。",
  },

  compUserAddress: {
    you: "自己",
  },

  compNewOrderForm: {
    introTxt: "若要下单卖出代币，您需要拥有此代币，并事先添加对于这一代币的交易授权。如果选项中没有想要交易的代币，可以在 \"我的代币\" 页面添加。",
    reviewOrder: "检阅挂单",
    btnModifyOrder: "修改挂单",
    btnSubmitOrder: "确认下单",
    btnSubmitOrderLoading: "正在下单，请稍候",
    successMessageShowJSON: "您已成功下单。以下是该挂单的 JSON 代码。",
    btnViewOrder: "查看挂单",
    btnViewOrderList: "查看您的挂单列表",
    btnCreateAnotherOrder: "创新新挂单",
    successMessageShort: "您已成功下单。",
    err: {
      tokenShouldBeDifferent: "卖出和买入的代币不能相同",
      noToken: "你没有这个代币",
      noAllowance: "你还没有添加这个代币的交易权限",
      orderUnfillable: "这个挂单不可交易",
    },
  },

  compOrderSummary: {
    orderNotFound: "没有找到挂单记录",
    showJsonCode: "显示 JSON 代码",
    yourOwnOrder: "这是您自己的挂单",
    youCannotFill: "这个挂单不可交易",
    tokenAmountFilled: "{tokenSymbol}已被吃单数量",
    tokenAmountAvailable: "{tokenSymbol}剩余数量",
    estimatedProtocolFee: "协议费（预估）",
    makerPay: "挂单者付",
    takerPay: "吃单者付",
    youPay: "您付",
    unfillableReason: {
      ORDER_UNFILLABLE: "这个挂单目前无法交易",
      Invalid: "挂单无效",
      InvalidMakerAssetAmount: "挂单的卖出代币量无效",
      InvalidTakerAssetAmount: "挂单的买入代币量无效",
      Expired: "挂单已经过期",
      FullyFilled: "挂单已经完成全部交易",
      Cancelled: "挂单已经被取消",
      OWN_ORDER: "这是您自己的挂单",
      NOT_TAKER: "您不是这个挂单指定的交易者",
      INSUFFICIENT_TAKER_ASSET: "您没有足够的 {tokenSymbol} 代币",
      INSUFFICIENT_TAKER_ALLOWANCE: "您还没有授予 {tokenSymbol} 代币足够的交易权限",
    },
    btnFillOrder: "提交",
    btnFillOrderLoading: "正在提交，请稍后",
    statusWaitingMatamask: "等待 MetaMask，请通过 MetaMask 确认交易。",
    statusSuccess: "您已成功提交吃单指令！",
    btnViewTradeHistory: "查看交易历史",
    statusFailed: "提交指令失败",
    cancelOrder: {
      areYouSure: "您确定要撤销这个挂单，使其无法交易吗？（您需要交付矿工Gas费）",
      doNotCancel: "不撤消",
      yesCancel: "确定，撤销挂单",
      cancelLoading: "正在撤销挂单",
    },
    deleteOrder: {
      areYouSure: "您确定要删除这个挂单的历史记录吗？（这个步骤不需要交付矿工Gas费）",
      doNotDelete: "不删除",
      yesDelete: "确定，删除挂单记录",
      deleteLoading: "正在删除挂单记录",
    },
  },

  compTradeSummary: {
    exChangeFeeYouPaid: "已付手续费",
    btnViewDetails: "查看详情",
  },

  compOrdersByTokenPair: {
    popularTradingPairs: "热门交易对",
    myWatchlist: "我关注的交易对",
    addNewTradingPair: "添加交易对",
    watched: "已关注",
    notWatched: "未关注",
    removeFromWatchlist: "移除关注",
    addToWatchlist: "添加关注",
    createOrder: "创建挂单",
    liveData: "实时数据",
    noAskOrder: "暂无卖出单",
    spread: "差价",
    noBidOrder: "暂无买入单",
  },

  compSimpleOrderSummary: {
    btnFillOrder: "吃单(卖出{tokenSymbol})",
    yourOrder: "您的挂单",
  },

  compAddTokenPairWatchForm: {
    title: "添加关注列表交易对",
    btnAdd: "添加交易对",
    btnAddLoading: "正在添加，请稍候",
    successMessage: "已成功添加 {tokenPair} 交易对到关注列表。"
  },

  compPublicFooter: {
    subscribeNewsletter: "订阅电子邮件",
  },

  compLogInWatcher: {
    logOutWarning: {
      title: "退出登录提醒",
      intro: "您将会在 {time} 分钟后自动退出登录。",
      btnKeepLoggedIn: "继续保持登录状态",
    }
  },

  feedbackForm: {
    introTxt: "您有任何问题、反馈或建议吗？您可以通过电邮联系我们：",
    buttonTxt: "联系我们",
  },

  loginPage: {
    title: '登 录',
    connectWallet: "连接钱包",
    connectMetaMask: "连接 MetaMask",
    introConnectMetaMask: "开始使用 LedgerDex 之前，请先连接 MetaMask。",
    introConnectMobileWallet: "开始使用 LedgerDex 之前，请先连接钱包。",
    connectMetaMaskError: "连接 MetaMask 失败，请重试。",
    connectWalletError: "连接钱包失败，请重试。",
    loginError: "登录失败，请重试。",
    preloaderMessage: "长时间没反应？请检查MetaMask，确保MetaMask已经连上网络。如果需要的话，请在MetaMask批准我们的连接请求。",
    metaMaskFullName: "浏览器插件钱包MetaMask",
    txtNeedMobileWallet: "若要使用 LedgerDex，您需要在我们支持的手机钱包 APP 里打开本网页。",
    txtNeeedMataMask1: "使用 LedgerDex 前，您需要安装",
    txtNeeedMataMask2: "。支持该插件的浏览器包括：Chrome、FireFox、Opera和Brave。",
    txtWrongNetwork: "对不起，您现在连接的以太坊网络我们并不支持。目前我们支持的以太坊网络包括：",
    txtLoginMetamaskFirst: "在登录本站之前请您先登录浏览器插件钱包MetaMask。",
    txtAccessDenied: "您在MetaMask上拒绝了我们的登陆请求，所以您无法登录和使用LedgerDex。",
    txtAccessRetry: "重试",
    txtPleaseSignMetaMask: "使用浏览器插件MetaMask轻松登录本站：点击MetaMask页面的“Sign”按钮即可，不需要注册和密码！",
    txtPleaseSignWallet: "使用钱包轻松登录，不需要注册和密码！",
    txtAgreeTermsFront: "我已阅读并接受LedgerDex的",
    TermsAndConditions: "服务条款",
    buttonTxtLoggingIn: "登录中",
    buttonTxtLogInUsingMetaMask: "通过 MetaMask 登录",
    buttonTxtLogInUsingWallet: "通过钱包登录",
    titleLocationBanned: "地区不在服务范围之内",
    txtLocationBanned: "根据您的IP地址，您是从以下国家/地区访问我们：{country}。对不起，我们不对您所在的国家/地区提供服务。",
    txtLocationBanBypassAgreement: "我确认我并不是以下国家/地区的居民：{country}。我愿意继续使用你们的服务。",
    buttonByPassLocationBan: "继续使用LedgerDex",
  },

  myTokensPage: {
    myAccount: "我的账号",
    popularTokens: "热门代币",
    trackedTokens: "我关注的代币",
    tableTitleToken: "代币",
    tableTitleBalance: "余额",
    tableTitleAllowance: "交易授权",
    tableTitleOrders: "挂单搜索",
    tableTitleManage: "管理",
    buttonTxtWrap: "包装ETH",
    buttonTxtUnwrap: "卸装WETH",
    buttonTxtBuyOrders: "买入单",
    buttonTxtSellOrders: "卖出单",
    buttonTxtActions: "相关操作",
    instantBuy: "购买",
    actionTxtBuy: "创建挂单：买入",
    actionTxtSell: "创建挂单：卖出",
    actionTxtSetAllowance: "添加交易授权",
    actionTxtRemoveAllowance: "取消交易授权",
    actionTxtStopTracking: "不再关注",
    actionTxtSend: "发送",
    tooltipTxtAllowance: "为确保智能合约能够安全地完成您的代币交易，我们首先需要您授予智能合约替您进行代币交易的权力，这一过程叫做交易授权（Allowance），对于每一种您需要卖出的代币，在交易之前都需要添加交易授权。",
    tooltipTxtWrapUnWrap: "因为以太币（ETH）目前还不能和其它 ERC20 代币直接进行交易，所以交易前需要您先将以太币（ETH）兑换成与其对等（1：1）的代币 WETH。把 ETH 换成 WETH 叫做“包装 ETH”（Wrap）。WETH 可以随时换回 ETH，这一过程叫“卸装 WETH”（Unwrap）。",
    tooltipTxtClickToSetAllowance: "点击这里添加交易授权",
    tooltipTxtClickToRemoveAllowance: "点击这里取消交易授权",
  },

  ERC20TokenPage: {
    title: "代币",
    titleManage: "管理",
    titleWrapUnwrap: "ETH 包装",
    titleTrade: "交易",
    titleMarketplace: "交易中心",
    titleTokenTracking: "代币关注",
    btnAddTokenTracking: "添加代币",
    btnRemoveTokenTracking: "取消关注",
    titlePopularSellOrders: "热门卖出单",
    titlePopularBuyOrders: "热门买入单",
    titleMoreSellOrders: "更多卖出单",
    titleMoreBuyOrders: "更多买入单",
    titleActiveTradingPairs: "活跃交易对",
    titleTrackedTradingPairs: "关注的交易对",
    displayNone: "无"
  },

  parseJsonOrderPage: {
    txtIntro: "请输入挂单的 JSON 代码:",
    err: {
      invalidJson: "JSON 代码不合规范",
    }
  },

  instantBuyTokenPage: {
    title: '一键购买',
    tokenNotFound: '对不起，找不到这个代币。',
    introTxt: '您可以在这里快速购买ERC20代币。这一功能通过<strong><a href="https://0x.org/instant" target="_blank">0x Instant</a></strong>实现，您可以直接使用以太币(ETH)来购买代币，不需要事先包装(Wrap)ETH，也不需要事先添加交易授权。',
    tokenNotAvailableForBuying: '对不起，这一代币目前无法通过这种方式购买。',
    notAvailableForInstant: '不支持一键购买',
    pleaseVerifiyToken: '在购买前，请核对代币信息，确认这是您要购买的代币:',
    btnTxtBuy: '一键购买',
  },

  helpContents,

  articles,

};
